import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m21.6 7.047-9-6.843c-.3-.196-.7-.293-1.1-.098-.3.196-.5.49-.5.88v13.686q0 .586.6.88c.1.098.3.098.4.098.2 0 .4-.098.6-.196l9-6.843c.2-.195.4-.489.4-.782s-.1-.586-.4-.782m-8.6 5.67V2.941l6.4 4.888zM1.6.204C1.3.008.9-.089.6.106q-.6.295-.6.88v13.686q0 .586.6.88c.1.098.3.098.4.098.2 0 .4-.098.6-.196l9-6.843c.2-.195.4-.489.4-.782s-.1-.586-.4-.782zM2 12.717V2.941L8.4 7.83z"
    }, null, -1)
  ]))]))
}
export default { render: render }